import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';

@Component({
	selector: 'app-timecard-record',
	templateUrl: './timecard-record.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class TimecardRecordComponent implements OnInit {
	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private router: Router) {}

	ngOnInit(): void {}
}
